import React, { useMemo, useState } from 'react'
import { appUrl, companyName, logoWhite, sessionName } from '../../../utils'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

export default function Header({ onSearch }) {
  const [searchInput, setSearchInput] = useState('')
  const [showSuggestions, setShowSuggestions] = useState(false)

  const { isCustomer, full_name, events = [] } = useSelector(
    state => state.session
  )
  const history = useHistory()

  const handleSearch = e => {
    e.preventDefault()
    if (onSearch) {
      onSearch(searchInput)
    }
  }

  const handleNavigateToEvent = event => {
    setShowSuggestions(false)
    setSearchInput('')
    history.push(appUrl({ url: event.slug_event_formatted }))
  }

  // Filtra eventos por nombre, lugar o tipo
  const filteredEvents = useMemo(() => {
    const term = searchInput.trim().toLowerCase()
    if (term.length < 2) return []

    return events
      .filter(ev => {
        const name = (ev.name_event || '').toLowerCase()
        const location = (ev.location_event || '').toLowerCase()
        const type = (ev.name_type_event || '').toLowerCase()
        return (
          name.includes(term) ||
          location.includes(term) ||
          type.includes(term)
        )
      })
      .slice(0, 8) // máximo 8 sugerencias
  }, [searchInput, events])

  const hasResults = filteredEvents.length > 0

  return (
    <>
      <div className="gradient-bar"></div>

      <header
        className="bg-white"
        style={{
          minHeight: '70px',
          padding: '25px 0px'
        }}
      >
        <div className="container-lg">
          <div className="d-flex align-items-center justify-content-between gap-4">
            {/* Logo */}
            <div className="flex-shrink-0">
              <a href={appUrl({ url: '/' })}>
                <h1 className="fs-4 fw-bold text-primary-custom mb-0 d-none">
                  {companyName()}
                </h1>
                <img src={logoWhite()} alt="Logo" style={{
                  maxHeight: '60px'
                }} />
              </a>
            </div>

            {/* Search form + autocomplete */}
            <div
              className="search-box-wrapper flex-grow-1 position-relative"
              style={{ maxWidth: '380px' }}
            >
              <form onSubmit={handleSearch} className='d-none d-lg-block'>
                <div className="search-box">
                  <input
                    type="text"
                    className="search-input"
                    placeholder="Busca por artista, evento o lugar"
                    value={searchInput}
                    onChange={e => {
                      setSearchInput(e.target.value)
                      setShowSuggestions(true)
                    }}
                    onFocus={() => {
                      if (searchInput.trim().length >= 2) {
                        setShowSuggestions(true)
                      }
                    }}
                    onBlur={() => {
                      // pequeño delay para permitir click en las opciones
                      setTimeout(() => setShowSuggestions(false), 150)
                    }}
                  />
                  <i className="fas fa-search search-icon" />
                </div>
              </form>

              {showSuggestions && searchInput.trim().length >= 2 && (
                <div className="search-autocomplete shadow-sm">
                  {hasResults ? (
                    <>
                      {filteredEvents.map(ev => (
                        <button
                          key={ev.id_event}
                          type="button"
                          className="search-autocomplete-item"
                          onMouseDown={e => {
                            // onMouseDown para que no dispare blur antes del click
                            e.preventDefault()
                            handleNavigateToEvent(ev)
                          }}
                        >
                          <div className="d-flex align-items-center">
                            <div className="search-autocomplete-avatar me-2">
                              <i className="fas fa-ticket-alt" />
                            </div>
                            <div className="text-start">
                              <div className="search-autocomplete-title">
                                {ev.name_event}
                              </div>
                              <div className="search-autocomplete-meta">
                                {ev.location_event} · {ev.date_formmatted_event}
                              </div>
                            </div>
                          </div>
                        </button>
                      ))}
                    </>
                  ) : (
                    <div className="search-autocomplete-empty">
                      No encontramos eventos para “{searchInput.trim()}”.
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Auth buttons */}
            <div className="d-flex align-items-center gap-3">
              {isCustomer ? (
                <>
                  <div
                    onClick={() => {
                      history.push(appUrl({ url: '/carrito' }))
                    }}
                    style={{ cursor: 'pointer' }}
                    rel="noopener noreferrer"
                    className="btn btn-link text-dark text-decoration-none fw-medium d-flex align-items-center gap-2"
                  >
                    <i className="fas fa-shopping-cart" />
                  </div>
                  <div
                    onClick={() => {
                      history.push(appUrl({ url: '/mis-tickets' }))
                    }}
                    style={{ cursor: 'pointer' }}
                    rel="noopener noreferrer"
                    className="btn btn-link text-dark text-decoration-none fw-medium d-flex align-items-center gap-2"
                  >
                    <i className="fas fa-user" />
                    <span className='d-none d-lg-block'>MI CUENTA ({full_name})</span>
                  </div>
                  <div
                    onClick={() => {
                      localStorage.removeItem(sessionName())
                      localStorage.removeItem('session-customer-storage')
                      window.location.href = appUrl({
                        url: '/cuenta/login'
                      })
                    }}
                    style={{ cursor: 'pointer' }}
                    className="btn fw-medium d-flex align-items-center gap-2"
                  >
                    <i className="fas fa-sign-out-alt" />
                    <span className='d-none d-lg-block'>Salir</span>
                  </div>
                </>
              ) : (
                <>
                  <a
                    href={isCustomer ? appUrl({ url: '/mis-tickets' }) : appUrl({ url: '/cuenta/login?redirect=' + appUrl({ url: '/mis-tickets' }) })}
                    className="btn btn-link text-dark text-decoration-none fw-medium d-flex align-items-center gap-2"
                  >
                    <i className="fas fa-shopping-cart" />
                  </a>
                  <a
                    href={appUrl({
                      url:
                        '/cuenta/login?redirect=' +
                        appUrl({ url: '/mis-tickets' })
                    })}
                    className="btn btn-link text-dark text-decoration-none fw-medium d-flex align-items-center gap-2"
                  >
                    <i className="fas fa-user" />
                    <span className='d-none d-lg-block'>INGRESA</span>
                  </a>
                  <a
                    href={appUrl({ url: '/cuenta/registro' })}
                    className="btn btn-link text-dark text-decoration-none fw-medium d-flex align-items-center d-none d-lg-block"
                  >
                    <i className="fas fa-user-plus mr-2" />
                    <span>REGÍSTRATE</span>
                  </a>
                </>
              )}
            </div>
          </div>
        </div>
      </header>
    </>
  )
}
